/**
 *  Handles keyboard interactions with selectable collections.
 */
function useSelectableCollectionKeyboard(props) {
  const {
    onIndexChange,
    onSelect
  } = props;
  const onKeyDown = e => {
    const maxItemIndex = (typeof props.collectionLength === "function" ? props.collectionLength() : props.collectionLength) - 1;
    const activeIndex = typeof props.activeIndex === "function" ? props.activeIndex() : props.activeIndex;
    let nextItemIndex = activeIndex;
    switch (e.key) {
      case "Enter":
        {
          e.preventDefault();
          onSelect?.();
          break;
        }
      case "ArrowDown":
        {
          e.preventDefault();
          nextItemIndex = Math.min(activeIndex + 1, maxItemIndex);
          break;
        }
      case "ArrowUp":
        {
          e.preventDefault();
          nextItemIndex = Math.max(activeIndex - 1, 0);
          break;
        }
      case "Home":
        {
          e.preventDefault();
          nextItemIndex = 0;
          break;
        }
      case "End":
        {
          e.preventDefault();
          nextItemIndex = maxItemIndex;
          break;
        }
    }
    if (nextItemIndex !== activeIndex && onIndexChange) {
      onIndexChange(nextItemIndex);
    }
  };
  return {
    onKeyDown
  };
}

export { useSelectableCollectionKeyboard };
